import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Fish from '../game/Fish';
import Kelp from '../game/Kelp';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import LevelBase from './LevelBase';

export default class Level2 extends LevelBase {
  static get KEY() { return 'Level2'; }

  constructor() {
    super({ key: Level2.KEY });
  }

  init() {
    gameData.config.level = 2;

    super.init();

    this.kelpA1 = null;
    this.kelpA2 = null;
    this.kelpA3 = null;
    this.kelpB1 = null;
    this.kelpB2 = null;
    this.kelpB3 = null;

    /** @type {Kelp[]} */
    this.kelp = null;
    this.fishies = null;
  }

  createNextScene () {
    super.createNextScene();

    const bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._6_Level_3_Lvl3_Bkgd, this.nextLvlCont).setOrigin(0);
  }

  createBackground () {
    super.createBackground();

    this.fishies = new Fish(this);
    this.add.existing(this.fishies);

    this.kelpA3 = new Kelp(this, 'B', .25, false);
    this.kelpA2 = new Kelp(this, 'B', .5, true);
    this.kelpA1 = new Kelp(this, 'A', 1, true);
    this.kelpA3.scaleX *= -1;
    this.kelpA3.x = 200;

    this.kelpB3 = new Kelp(this, 'A', .25, false);
    this.kelpB2 = new Kelp(this, 'A', .5, true);
    this.kelpB1 = new Kelp(this, 'B', 1, true);
    this.kelpB1.x = 800;
    this.kelpB2.x = 800;
    this.kelpB3.scaleX *= -1;
    this.kelpB3.x = 1100;

    this.add.existing(this.kelpA3);
    this.add.existing(this.kelpA2);
    this.add.existing(this.kelpA1);
    this.add.existing(this.kelpB3);
    this.add.existing(this.kelpB2);
    this.add.existing(this.kelpB1);

    this.kelp = [this.kelpA1, this.kelpA2, this.kelpA3, this.kelpB1, this.kelpB2, this.kelpB3];
  }

  fullClean () {
    for (let k = 0; k < this.kelp.length; k++) {
      this.kelp[k].cleanUp();
      this.kelp[k].destroy();
    }
    this.kelp = [];

    this.fishies.cleanUp();
    this.fishies.destroy();

    super.fullClean();
  }

  cleanUp () {
    for (let k = 0; k < this.kelp.length; k++) {
      this.kelp[k].cleanUp();
      this.kelp[k].destroy();
    }
    this.kelp = [];

    this.fishies.cleanUp();
    this.fishies.destroy();

    super.cleanUp();
  }
}